import {
    BATCHES_FAILURE,
    BATCHES_LOAD,
    BATCHES_SUCCESS
} from './batchesActions';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let  newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                batches: []
            };

            return isEqual(state, newState) ? state : newState;

        case BATCHES_LOAD:
            newState = {
                ...state,
                batches: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case BATCHES_SUCCESS:
            newState = {
                ...state,
                batches: action.batches,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case BATCHES_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getBatchesEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'batches')
);

export const getPages = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'count')
);

export const getIsBatchesLoading = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'loading')
);

export const getBatches = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'batches')
);

export const getBatchesError = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'error')
);

export const getBatchesErrorMessage = createSelector(
    getBatchesError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getBatchesEntity,
    (entity) => get(entity, 'hasMore')
);
